import React, { useState } from "react";
import IndustrialFooter from "../../../IndustrialFooter/IndustrialFooter";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./GearGrinding.css";

const GearGrinding = () => {
  const navigate = useNavigate();
  const items = [
    { id: 1, image: require("../../../../assets/images/gear and gear cutting tools grinding/1.PNG"), title: "Variant 1" },
    { id: 2, image: require("../../../../assets/images/gear and gear cutting tools grinding/2.png"), title: "Variant 2" },
    { id: 3, image: require("../../../../assets/images/gear and gear cutting tools grinding/3.png"), title: "Variant 3" },
    { id: 4, image: require("../../../../assets/images/gear and gear cutting tools grinding/4.png"), title: "Variant 4" },
    { id: 5, image: require("../../../../assets/images/gear and gear cutting tools grinding/5.png"), title: "Variant 5" },
  ];

  const [selectedItem, setSelectedItem] = useState(items[0]);

  return (
    <motion.div
    initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="ceramic-page">
        <div className="back-btn-wrapper" onClick={() => navigate(-1)}>
        <svg
          className="back-icon"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 18L9 12L15 6"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span>Back to Products</span>
      </div>



      <h1>Gear and Gear Cutting Tools Grinding</h1>
        <div className="ceramic-layout">
          {/* LEFT */}
          <div className="left-section">
            <div className="main-display">
              <img src={selectedItem.image} alt={selectedItem.title} />
            </div>

            <div className="thumbnail-grid">
              {items.map((item) => (
                <div
                  key={item.id}
                  className={`thumbnail ${
                    selectedItem.id === item.id ? "active" : ""
                  }`}
                  onClick={() => setSelectedItem(item)}
                >
                  <img src={item.image} alt={item.title} />
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT */}
          <div className="right-section">
            <h2>Gear and Gear Cutting Tools Grinding</h2>
            <Description />
          </div>
        </div>
      </div>

      <IndustrialFooter />
    </motion.div>
  );
};

/* 🔹 Separate description function */
const Description = () => {
  return (
    <>
    <div className="dc-text-block">
      <p>
            We have best suitable specifications with high performance grains like
            Pink Aluminium Oxide, Mono-crystalline and Ceramic grains with high
            performance bond for below applications:
          </p>
          <ol className="detail-list">
            <li>Single rib gear teeth grinding wheels (Q-face wheel)</li>
            <li>Multi rib gear grinding (multi profile gear grinding)</li>
            <li>Straight cup wheels for bevel gear grinding</li>
            <li>Blank grinding wheels for gear honing</li>
            <li>Hob re-sharpening</li>
            <li>Broach grinding</li>
            <li>Tool and cutter grinder</li>
          </ol>
    </div>
    </>
  );
};

export default GearGrinding;
